import instance from "services/axiosServices";

/**
 * @description Busca os detalhes de um empreendimento.
 * @param {string} idEmpreendimento - Id do empreendimento.
 * @returns {Promise<any>} - Retorna os detalhes do empreendimento.
 */
export const getProdutosDetalhesV1 = async (
  idEmpreendimento: string
): Promise<any> => {
  const url = `locais/app-web/produtos/detalhes-por-idEmpreendimento/v1?idEmpreendimento=${idEmpreendimento}`;
  const response = await instance.get(url);
  return response?.data;
};
